import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Form,
    message,
    Row,
    Col,
    InputNumber,
    Table, Modal, AutoComplete,
} from 'antd';
import axios from 'axios';
import {copyToClipboard, fetchTokenOptions, formattedAddress} from "../../util";
import { useNavigate } from 'react-router-dom';


const { Content } = Layout;
const { Option } = Select;
message.config({ duration: 10 , zIndex: 9999}); // 3秒后自动消失


const AddLiquidityAndBuy = () => {
    const navigate = useNavigate();
    const [walletGroups, setWalletGroups] = useState([]);  // 钱包组列表
    const [projectList, setProjectList] = useState([]);  // 项目列表
    const [selectedProject, setSelectedProject] = useState(null);  // 选中的项目
    const [walletAddress, setWalletAddress] = useState('');  // 钱包地址
    const [loading, setLoading] = useState(false);  // 加载状态
    const [form] = Form.useForm();  // 表单实例
    const [liquidityRecords, setLiquidityRecords] = useState([]);  // 添加流动性记录
    const [selectedChain, setSelectedChain] = useState(null);  // 选中的链
    const [selectedGroup, setSelectedGroup] = useState([]); // 选中的钱包组
    const [price, setPrice] = useState(null);  // 用来存储价格
    const [snip_total_amount, setSnipTotalAmount] = useState(null);  // 用来存储价格
    const [detailModalVisible, setDetailModalVisible] = useState(false);  // 控制弹窗显示
    const [tokenOptions, setTokenOptions] = useState({});

    useEffect(() => {
        const loadTokenOptions = async () => {
            const data = await fetchTokenOptions();
            setTokenOptions(data);
        };

        loadTokenOptions();
    }, []);

    useEffect(() => {
        fetchProjects();
        fetchLiquidityRecords(); // 获取添加流动性记录
        fetchWalletGroups();
    }, []);

    useEffect(() => {
        if (selectedProject) {
            // 清空钱包组选项
            setSelectedGroup([]);
            form.setFieldsValue({ group_id: [] });  // 强制清空钱包组选项
        }
    }, [selectedProject]);

    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 999 },
            });
            console.log(response.data);
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);

                // setSelectedGroup(response.data.data.items[0].group_id);
                // console.log(response.data.data.items[0].group_id);
            } else {
                if(response.data.code === -5) {
                    console.log("token 过期")
                    message.error('token 过期');
                    navigate('/login');
                } else {
                    message.error(response.data.msg);
                }
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 获取项目列表
    const fetchProjects = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/projects/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                setProjectList(response.data.data.item);  // 存储项目列表
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 获取流动性记录
    const fetchLiquidityRecords = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/projects/liquidity/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { project_name: selectedProject },  // 选中的项目
            });
            if (response.data.code === 0) {
                setLiquidityRecords(response.data.data.items);
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 提交表单，添加流动性
    const addLiquidity = async (values) => {
        setLoading(true);

        const payload = {
            project_name: selectedProject,
            group_ids: [values.group_id],
            project_token_amount: values.project_token_amount,
            liquidity_token_address: values.liquidity_token_address,
            liquidity_token_amount: values.liquidity_token_amount,
            percentage: parseInt(values.percentage, 10),
        };

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/v1/projects/liquidity/add', payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                message.success('添加流动性成功');
                fetchLiquidityRecords(); // 重新获取流动性记录
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const handleEstimate = async (values) => {
        const token = localStorage.getItem('token');
        try {
            setLoading(true);
            // 请求预估接口
            const response = await axios.post('/api/v1/projects/liquidity/estimate', {
                project_name: values.project_name,
                group_ids: selectedGroup,  // 假设只有一个钱包组
                project_token_amount: values.project_token_amount,
                liquidity_token_address: values.liquidity_token_address,
                liquidity_token_amount: values.liquidity_token_amount,
                percentage: values.percentage,
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data.code === 0) {
                // 获取价格，并弹出弹窗显示
                const  price  = response.data.data.price;
                const snip_total_amount = response.data.data.snip_total_amount;
                setSnipTotalAmount(snip_total_amount);
                setPrice(price);  // 设置返回的价格
                setDetailModalVisible(true);  // 显示弹窗
            } else {
                console.log(response.data.msg);
                message.error(response.data.msg);


            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirm = async (values) => {
        const token = localStorage.getItem('token');
        try {
            setLoading(true);
            const values = await form.validateFields();
            // 请求添加流动性接口
            const response = await axios.post('/api/v1/projects/liquidity/add', {
                project_name: values.project_name,
                group_ids: selectedGroup,  // 传递多个钱包组ID
                project_token_amount: values.project_token_amount,
                liquidity_token_address: values.liquidity_token_address,
                liquidity_token_amount: values.liquidity_token_amount,
                percentage: values.percentage,
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data.code === 0) {
                message.success('添加流动性成功');
            } else {
                message.error("添加失败")
                // message.error(response.data.msg);
            }
        } catch (error) {
            message.error('请求失败，无法添加流动性');
        } finally {
            setLoading(false);
            setDetailModalVisible(false);  // 关闭弹窗
        }
    };

    // 表格列定义
    const columns = [
        { title: '序号', dataIndex: 'index', render: (_, __, index) => index + 1 },
        { title: '项目名称', dataIndex: 'project_name' },
        { title: '代币地址', dataIndex: 'project_token_address' , render: (text) => (
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    {/* 地址链接 */}
                    <a href={`https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        {
            title: '池子代币地址', dataIndex: 'liquidity_token_address', render: (text) => (
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    {/* 地址链接 */}
                    <a href={`https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
    )
        },
        { title: '添加的项目Token数量', dataIndex: 'project_token_amount' },
        {
            title: '使用的钱包组',
            dataIndex: 'wallet_group_name_list',
            render: (walletGroupNames) => walletGroupNames?.join(',\n') || '-' // 处理数组换行
        },
        {
            title: '钱包组主账号地址',
            dataIndex: 'project_create_address',
            render:  (text) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {/* 地址链接 */}
                        <a href={`https://basescan.org/address/${text}`}
                           target="_blank"
                           rel="noopener noreferrer">
                            {formattedAddress(text)}
                        </a>

                        {/* 复制按钮 */}
                        <Button
                            size="small"
                            onClick={() => copyToClipboard(text)}>
                            复制
                        </Button>
                    </div>
            )
        },
        { title: '钱包组主账号出资', dataIndex: 'liquidity_token_amount' },
        { title: '钱包组Snipe比例', dataIndex: 'percentage' },
        { title: '状态', dataIndex: 'status' },
    ];

    const handleProjectChange = (projectName) => {
        const selected = projectList.find((project) => project.project_name === projectName);
        if (selected) {
            setSelectedProject(projectName);
            setSelectedGroup([]); // 清空之前选中的钱包组
            form.setFieldValue({group_id: null})
        }
    };

    return (
        <Content style={{ padding: '20px' }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleEstimate}
                style={{ maxWidth: '100%', margin: '0 auto' }}
            >
                {/* 第一行 */}
                <Row gutter={16}>
                    <Col span={3}>
                        <Form.Item
                            name="project_name"
                            rules={[{ required: true, message: '请选择项目名' }]}
                        >
                            <Select
                                        allowClear
                                showSearch
                                placeholder="选择项目"
                                style={{ width: '100%' }}
                                onChange={handleProjectChange} // 当项目变化时更新钱包组
                            >
                                {projectList.map((project) => (
                                    <Option key={project.id} value={project.project_name}>
                                        {project.project_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item
                            name="group_id"
                            rules={[{ required: true, message: '请选择钱包组' }]}
                        >
                            <Select
                                        allowClear
                                showSearch
                                mode="multiple"
                                placeholder="选择钱包组"
                                // onSearch={fetchWalletGroups}
                                style={{ width: '100%' }}
                                onChange={setSelectedGroup}  // 更新选中的钱包组
                                disabled={!selectedProject} // 如果没有选中项目，禁用钱包组选择
                            >
                                {selectedProject &&
                                    projectList
                                        .find((project) => project.project_name === selectedProject)
                                        .wallet_group_list.map((group) => (
                                        <Option key={group.id} value={group.id}>
                                            {group.name}
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name="project_token_amount"
                            initialValue={1000000000}
                            rules={[{ required: true, message: '请输入项目Token数量' }]}
                        >
                            <Input placeholder="项目Token数量" type="number" />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="liquidity_token_address"
                            rules={[{ required: true, message: '请输入 Quote Token 地址' }]}
                        >
                            <AutoComplete
                                placeholder="Quote Token 地址"
                                onChange={(value) => form.setFieldsValue({ liquidity_token_address: value })}
                                style={{ width: '100%' }}
                                options={Array.from(new Map(
                                    Object.entries(tokenOptions).flatMap(([chain_name, tokens]) =>
                                        tokens.map(token => [token.address, {
                                            value: token.address,
                                            label: `${chain_name}-${token.name} - ${token.address}`,
                                        }])
                                    )
                                ).values())} // 直接展示所有代币，不按链区分，并使用 Map 去重
                                filterOption={(inputValue, option) =>
                                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="liquidity_token_amount"
                            rules={[{ required: true, message: '请输入钱包组主账号出资' }]}
                        >
                            <Input placeholder="钱包组主账号出资" type="number" />
                        </Form.Item>
                    </Col>
                {/*</Row>*/}

                {/* 第二行 */}
                {/*<Row gutter={16}>*/}
                    <Col span={4}>
                        <Form.Item
                            name="percentage"
                            rules={[{ required: true, message: '请输入钱包组Snipe比例' }]}
                        >
                            <InputNumber
                                placeholder="钱包组Snipe比例"
                                addonAfter="%"
                                style={{ width: '100%' }}
                                min={0}
                                max={100}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} block>
                                预估价格
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>

                {/* 流动性添加确认弹窗 */}
                <Modal
                    title="预估代币添加流动性后价格"
                    visible={detailModalVisible}
                    onCancel={() => setDetailModalVisible(false)}
                    footer={[
                        <Button key="back" onClick={() => setDetailModalVisible(false)}>
                            关闭
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            loading={loading}
                            onClick={handleConfirm}  // 点击确认按钮时调用 handleConfirm
                        >
                            确定
                        </Button>,
                    ]}
                >
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <div>预估代币添加流动性后，价格：{price}，snip的代币总额：{snip_total_amount}</div>
                    </div>
                </Modal>
            </Form>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={liquidityRecords}
                loading={loading}
                pagination={{ pageSize: 10, showSizeChanger: false, }}
            />
        </Content>
    );
};

export default AddLiquidityAndBuy;
